var _rect, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPhotoshopLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 130,
    height: 130,
    viewBox: "0 0 130 130",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "luminosity"
    }
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 130,
    height: 130,
    rx: 65,
    fill: "#ADADAD"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M87.6417 53.3359C83.3624 53.3359 81.9001 55.5576 81.9001 57.3905C81.9001 59.3901 82.875 60.7787 88.6168 63.8337C97.1209 68.0551 99.7751 72.1097 99.7751 78.0531C99.7751 86.9401 93.1668 91.7169 84.2292 91.7169C79.5167 91.7169 75.4541 90.717 73.125 89.3286C72.7459 89.162 72.6917 88.8843 72.6917 88.4398V80.2748C72.6917 79.7194 72.9625 79.5526 73.3419 79.8305C76.7543 82.1079 80.6542 83.1076 84.2292 83.1076C88.5084 83.1076 90.2959 81.2746 90.2959 78.775C90.2959 76.7755 89.05 74.9981 83.5791 72.1097C75.8873 68.3328 72.6917 64.5003 72.6917 58.1127C72.6917 50.9474 78.1627 45.0043 87.6417 45.0043C92.3 45.0043 95.55 45.7265 97.3375 46.5595C97.7708 46.8372 97.8791 47.2815 97.8791 47.6702V55.2797C97.8791 55.724 97.6083 56.0019 97.0665 55.835C94.6833 54.2802 91.1625 53.3359 87.6417 53.3359ZM41.0583 59.9456C42.3042 60.0567 43.2792 60.0567 45.4458 60.0567C51.7836 60.0567 57.7418 57.7795 57.7418 48.948C57.7418 41.894 53.4625 38.339 46.2584 38.339C44.0919 38.339 42.0334 38.45 41.0583 38.5056V59.9456ZM31.4168 30.4516C31.4168 30.0629 32.1753 29.785 32.6083 29.785C36.0752 29.6184 41.221 29.5073 46.5834 29.5073C61.5875 29.5073 67.4374 37.95 67.4374 48.7257C67.4374 62.8338 57.4707 68.8882 45.2292 68.8882C43.1709 68.8882 42.4669 68.7771 41.0041 68.7771V90.1061C41.0041 90.5504 40.8416 90.7725 40.3542 90.7725H32.0667C31.6334 90.7725 31.4166 90.6059 31.4166 90.1061L31.4168 30.4516Z",
    fill: "#161616"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhotoshopLogo);
export default __webpack_public_path__ + "static/media/photoshop-logo.87c6f0dff5ffe9637965798a934943e3.svg";
export { ForwardRef as ReactComponent };